import {
  IdentityFragment,
  IdentityQuery,
  IdentityQueryVariables,
  useIdentityQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

export const useIdentity = withStandardGetHook<
  IdentityQuery,
  IdentityFragment,
  'identity',
  IdentityQueryVariables
>(useIdentityQuery, 'identity', {
  fetchPolicy: 'cache-first',
});
